/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateDanceRequest,
  FileResult,
  Result,
  ResultOfDanceDetail,
  ResultOfIReadOnlyListOfChoreographerListItem,
  ResultOfIReadOnlyListOfDanceActivityFeedItem,
  ResultOfIReadOnlyListOfDanceActivityItem,
  ResultOfIReadOnlyListOfDanceListItem,
  SendDanceReminderRequest,
  UpdateDanceRequest,
} from '../models/index';
import {
    CreateDanceRequestFromJSON,
    CreateDanceRequestToJSON,
    FileResultFromJSON,
    FileResultToJSON,
    ResultFromJSON,
    ResultToJSON,
    ResultOfDanceDetailFromJSON,
    ResultOfDanceDetailToJSON,
    ResultOfIReadOnlyListOfChoreographerListItemFromJSON,
    ResultOfIReadOnlyListOfChoreographerListItemToJSON,
    ResultOfIReadOnlyListOfDanceActivityFeedItemFromJSON,
    ResultOfIReadOnlyListOfDanceActivityFeedItemToJSON,
    ResultOfIReadOnlyListOfDanceActivityItemFromJSON,
    ResultOfIReadOnlyListOfDanceActivityItemToJSON,
    ResultOfIReadOnlyListOfDanceListItemFromJSON,
    ResultOfIReadOnlyListOfDanceListItemToJSON,
    SendDanceReminderRequestFromJSON,
    SendDanceReminderRequestToJSON,
    UpdateDanceRequestFromJSON,
    UpdateDanceRequestToJSON,
} from '../models/index';

export interface ApiChoreographersGetRequest {
    xTenantID?: number;
}

export interface ApiDancesActivityGetRequest {
    xTenantID?: number;
}

export interface ApiDancesDanceIdActivityGetRequest {
    danceId: number;
    xTenantID?: number;
}

export interface ApiDancesDanceIdCostumeImagePostRequest {
    danceId: number;
    xTenantID?: number;
    file?: Blob;
}

export interface ApiDancesDanceIdDeleteRequest {
    danceId: number;
    xTenantID?: number;
}

export interface ApiDancesDanceIdDrivePostRequest {
    danceId: number;
    xTenantID?: number;
}

export interface ApiDancesDanceIdFilesGetRequest {
    danceId: number;
    xTenantID?: number;
}

export interface ApiDancesDanceIdGetRequest {
    danceId: number;
    xTenantID?: number;
}

export interface ApiDancesDanceIdMusicPostRequest {
    danceId: number;
    xTenantID?: number;
    file?: Blob;
}

export interface ApiDancesDanceIdPutRequest {
    danceId: number;
    updateDanceRequest: UpdateDanceRequest;
    xTenantID?: number;
}

export interface ApiDancesDanceIdReminderPostRequest {
    danceId: number;
    sendDanceReminderRequest: SendDanceReminderRequest;
    xTenantID?: number;
}

export interface ApiDancesGetRequest {
    includeArchived?: boolean;
    xTenantID?: number;
}

export interface ApiDancesPostRequest {
    createDanceRequest: CreateDanceRequest;
    xTenantID?: number;
}

/**
 * 
 */
export class DancesApi extends runtime.BaseAPI {

    /**
     * People who have the choreographer role, including contract status. A choreographer does not receive this list.
     * List choreographers
     */
    async apiChoreographersGetRaw(requestParameters: ApiChoreographersGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfIReadOnlyListOfChoreographerListItem>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/choreographers`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfIReadOnlyListOfChoreographerListItemFromJSON(jsonValue));
    }

    /**
     * People who have the choreographer role, including contract status. A choreographer does not receive this list.
     * List choreographers
     */
    async apiChoreographersGet(requestParameters: ApiChoreographersGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfIReadOnlyListOfChoreographerListItem> {
        const response = await this.apiChoreographersGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Recent activity across dances. Admin and Staff only.
     * List studio dance activity
     */
    async apiDancesActivityGetRaw(requestParameters: ApiDancesActivityGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfIReadOnlyListOfDanceActivityFeedItem>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/dances/activity`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfIReadOnlyListOfDanceActivityFeedItemFromJSON(jsonValue));
    }

    /**
     * Recent activity across dances. Admin and Staff only.
     * List studio dance activity
     */
    async apiDancesActivityGet(requestParameters: ApiDancesActivityGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfIReadOnlyListOfDanceActivityFeedItem> {
        const response = await this.apiDancesActivityGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Activity for one dance. A choreographer only receives activity for their own dances.
     * List dance activity
     */
    async apiDancesDanceIdActivityGetRaw(requestParameters: ApiDancesDanceIdActivityGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfIReadOnlyListOfDanceActivityItem>> {
        if (requestParameters['danceId'] == null) {
            throw new runtime.RequiredError(
                'danceId',
                'Required parameter "danceId" was null or undefined when calling apiDancesDanceIdActivityGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/dances/{danceId}/activity`;
        urlPath = urlPath.replace(`{${"danceId"}}`, encodeURIComponent(String(requestParameters['danceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfIReadOnlyListOfDanceActivityItemFromJSON(jsonValue));
    }

    /**
     * Activity for one dance. A choreographer only receives activity for their own dances.
     * List dance activity
     */
    async apiDancesDanceIdActivityGet(requestParameters: ApiDancesDanceIdActivityGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfIReadOnlyListOfDanceActivityItem> {
        const response = await this.apiDancesDanceIdActivityGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Stores one JPG, PNG, WEBP, or GIF on the dance. A choreographer can upload only for their own dance.
     * Upload a costume reference image
     */
    async apiDancesDanceIdCostumeImagePostRaw(requestParameters: ApiDancesDanceIdCostumeImagePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfDanceDetail>> {
        if (requestParameters['danceId'] == null) {
            throw new runtime.RequiredError(
                'danceId',
                'Required parameter "danceId" was null or undefined when calling apiDancesDanceIdCostumeImagePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }


        let urlPath = `/api/dances/{danceId}/costume-image`;
        urlPath = urlPath.replace(`{${"danceId"}}`, encodeURIComponent(String(requestParameters['danceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfDanceDetailFromJSON(jsonValue));
    }

    /**
     * Stores one JPG, PNG, WEBP, or GIF on the dance. A choreographer can upload only for their own dance.
     * Upload a costume reference image
     */
    async apiDancesDanceIdCostumeImagePost(requestParameters: ApiDancesDanceIdCostumeImagePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfDanceDetail> {
        const response = await this.apiDancesDanceIdCostumeImagePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Admin or Staff deletes a dance and its activity.
     * Delete a dance
     */
    async apiDancesDanceIdDeleteRaw(requestParameters: ApiDancesDanceIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters['danceId'] == null) {
            throw new runtime.RequiredError(
                'danceId',
                'Required parameter "danceId" was null or undefined when calling apiDancesDanceIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/dances/{danceId}`;
        urlPath = urlPath.replace(`{${"danceId"}}`, encodeURIComponent(String(requestParameters['danceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Admin or Staff deletes a dance and its activity.
     * Delete a dance
     */
    async apiDancesDanceIdDelete(requestParameters: ApiDancesDanceIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.apiDancesDanceIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Copies the music file and costume reference image into the Glass House 2027 Competitive Music folder.
     * Copy dance files to Google Drive
     */
    async apiDancesDanceIdDrivePostRaw(requestParameters: ApiDancesDanceIdDrivePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters['danceId'] == null) {
            throw new runtime.RequiredError(
                'danceId',
                'Required parameter "danceId" was null or undefined when calling apiDancesDanceIdDrivePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/dances/{danceId}/drive`;
        urlPath = urlPath.replace(`{${"danceId"}}`, encodeURIComponent(String(requestParameters['danceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Copies the music file and costume reference image into the Glass House 2027 Competitive Music folder.
     * Copy dance files to Google Drive
     */
    async apiDancesDanceIdDrivePost(requestParameters: ApiDancesDanceIdDrivePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.apiDancesDanceIdDrivePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Downloads a zip of the music file, costume reference image, and costume notes for one dance.
     * Download dance files
     */
    async apiDancesDanceIdFilesGetRaw(requestParameters: ApiDancesDanceIdFilesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FileResult>> {
        if (requestParameters['danceId'] == null) {
            throw new runtime.RequiredError(
                'danceId',
                'Required parameter "danceId" was null or undefined when calling apiDancesDanceIdFilesGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/dances/{danceId}/files`;
        urlPath = urlPath.replace(`{${"danceId"}}`, encodeURIComponent(String(requestParameters['danceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FileResultFromJSON(jsonValue));
    }

    /**
     * Downloads a zip of the music file, costume reference image, and costume notes for one dance.
     * Download dance files
     */
    async apiDancesDanceIdFilesGet(requestParameters: ApiDancesDanceIdFilesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FileResult> {
        const response = await this.apiDancesDanceIdFilesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns one dance when the caller is allowed to see it. The internal note is omitted for a choreographer.
     * Get a dance
     */
    async apiDancesDanceIdGetRaw(requestParameters: ApiDancesDanceIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfDanceDetail>> {
        if (requestParameters['danceId'] == null) {
            throw new runtime.RequiredError(
                'danceId',
                'Required parameter "danceId" was null or undefined when calling apiDancesDanceIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/dances/{danceId}`;
        urlPath = urlPath.replace(`{${"danceId"}}`, encodeURIComponent(String(requestParameters['danceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfDanceDetailFromJSON(jsonValue));
    }

    /**
     * Returns one dance when the caller is allowed to see it. The internal note is omitted for a choreographer.
     * Get a dance
     */
    async apiDancesDanceIdGet(requestParameters: ApiDancesDanceIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfDanceDetail> {
        const response = await this.apiDancesDanceIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Stores one MP3, M4A, or AAC file on the dance. A choreographer can upload only for their own dance. WAV is rejected. A saved music link is cleared.
     * Upload dance music
     */
    async apiDancesDanceIdMusicPostRaw(requestParameters: ApiDancesDanceIdMusicPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfDanceDetail>> {
        if (requestParameters['danceId'] == null) {
            throw new runtime.RequiredError(
                'danceId',
                'Required parameter "danceId" was null or undefined when calling apiDancesDanceIdMusicPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }


        let urlPath = `/api/dances/{danceId}/music`;
        urlPath = urlPath.replace(`{${"danceId"}}`, encodeURIComponent(String(requestParameters['danceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfDanceDetailFromJSON(jsonValue));
    }

    /**
     * Stores one MP3, M4A, or AAC file on the dance. A choreographer can upload only for their own dance. WAV is rejected. A saved music link is cleared.
     * Upload dance music
     */
    async apiDancesDanceIdMusicPost(requestParameters: ApiDancesDanceIdMusicPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfDanceDetail> {
        const response = await this.apiDancesDanceIdMusicPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Admin or Staff updates the dance, its checklist, cast, and internal note. A choreographer updates only their own dance: routine, choreography, music status, costume, and cast. Name, assignment, archive, and the internal note stay as the studio left them. File upload is separate.
     * Update a dance
     */
    async apiDancesDanceIdPutRaw(requestParameters: ApiDancesDanceIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfDanceDetail>> {
        if (requestParameters['danceId'] == null) {
            throw new runtime.RequiredError(
                'danceId',
                'Required parameter "danceId" was null or undefined when calling apiDancesDanceIdPut().'
            );
        }

        if (requestParameters['updateDanceRequest'] == null) {
            throw new runtime.RequiredError(
                'updateDanceRequest',
                'Required parameter "updateDanceRequest" was null or undefined when calling apiDancesDanceIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/dances/{danceId}`;
        urlPath = urlPath.replace(`{${"danceId"}}`, encodeURIComponent(String(requestParameters['danceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateDanceRequestToJSON(requestParameters['updateDanceRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfDanceDetailFromJSON(jsonValue));
    }

    /**
     * Admin or Staff updates the dance, its checklist, cast, and internal note. A choreographer updates only their own dance: routine, choreography, music status, costume, and cast. Name, assignment, archive, and the internal note stay as the studio left them. File upload is separate.
     * Update a dance
     */
    async apiDancesDanceIdPut(requestParameters: ApiDancesDanceIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfDanceDetail> {
        const response = await this.apiDancesDanceIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sends one email to the choreographer about what is still missing on this dance.
     * Email a dance reminder
     */
    async apiDancesDanceIdReminderPostRaw(requestParameters: ApiDancesDanceIdReminderPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters['danceId'] == null) {
            throw new runtime.RequiredError(
                'danceId',
                'Required parameter "danceId" was null or undefined when calling apiDancesDanceIdReminderPost().'
            );
        }

        if (requestParameters['sendDanceReminderRequest'] == null) {
            throw new runtime.RequiredError(
                'sendDanceReminderRequest',
                'Required parameter "sendDanceReminderRequest" was null or undefined when calling apiDancesDanceIdReminderPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/dances/{danceId}/reminder`;
        urlPath = urlPath.replace(`{${"danceId"}}`, encodeURIComponent(String(requestParameters['danceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendDanceReminderRequestToJSON(requestParameters['sendDanceReminderRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Sends one email to the choreographer about what is still missing on this dance.
     * Email a dance reminder
     */
    async apiDancesDanceIdReminderPost(requestParameters: ApiDancesDanceIdReminderPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.apiDancesDanceIdReminderPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Admin and Staff see every dance. A choreographer sees only their own dances, without archived ones. The list is empty of other people\'s dances before it leaves the API.
     * List dances
     */
    async apiDancesGetRaw(requestParameters: ApiDancesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfIReadOnlyListOfDanceListItem>> {
        const queryParameters: any = {};

        if (requestParameters['includeArchived'] != null) {
            queryParameters['includeArchived'] = requestParameters['includeArchived'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/dances`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfIReadOnlyListOfDanceListItemFromJSON(jsonValue));
    }

    /**
     * Admin and Staff see every dance. A choreographer sees only their own dances, without archived ones. The list is empty of other people\'s dances before it leaves the API.
     * List dances
     */
    async apiDancesGet(requestParameters: ApiDancesGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfIReadOnlyListOfDanceListItem> {
        const response = await this.apiDancesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Admin or Staff creates a dance and assigns an active choreographer. The choreographer cannot create a dance.
     * Create a dance
     */
    async apiDancesPostRaw(requestParameters: ApiDancesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfDanceDetail>> {
        if (requestParameters['createDanceRequest'] == null) {
            throw new runtime.RequiredError(
                'createDanceRequest',
                'Required parameter "createDanceRequest" was null or undefined when calling apiDancesPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/dances`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDanceRequestToJSON(requestParameters['createDanceRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfDanceDetailFromJSON(jsonValue));
    }

    /**
     * Admin or Staff creates a dance and assigns an active choreographer. The choreographer cannot create a dance.
     * Create a dance
     */
    async apiDancesPost(requestParameters: ApiDancesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfDanceDetail> {
        const response = await this.apiDancesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
